import React, {Fragment, useState, useEffect} from 'react';
import {Divider, Row, Text, Button, Tag, Heading} from '../Widgets';
import {Context} from '../AppContext';
import {Alert} from 'antd';
import {
  LOGISTIC_STATUS,
  LOGISTIC_STATUS_SELF,
  REVIEW_STATUS,
  PRODUCTION_STATUS,
} from '../dictionary';
const appConfig = require('../data.json');

const REVIEW_STATUS_COLORS = {
  waiting: '#999',
  reupload: '#999',
  pending: '#D7BD23',
  accepted: '#4BAA70',
  rejected: '#C24C4C',
  void: '#C24C4C',
};

const PRODUCTION_STATUS_COLORS = {
  waiting: '#C24C4C',
  pending: '#C24C4C',
  preparing: '#D7BD23',
  in_production: '#D7BD23',
  completed: '#4BAA70',
  in_storage: '#4BAA70',
};

export default function OrderItems({type, order}) {
  const app = React.useContext(Context);
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [cart, setCart] = useState();
  const {modalContent} = app.state;

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        let resp = await app.actions.getOrderItems({
          order: order.id,
        });
        setRecords(resp);
      } catch (err) {
        console.warn(err);
      }

      try {
        let _cart = JSON.parse(order.cart);
        setCart(_cart);
      } catch (err) {
        console.warn(err);
      }
      setLoading(false);
    })();
  }, [order, app.actions]);

  useEffect(() => {
    if (!modalContent) {
      setCart(null);
    }
  }, [modalContent]);

  if (loading) {
    <Heading size="sm">載入中</Heading>;
  }

  if (!cart) {
    return null;
  }

  return (
    <div>
      {(type === 'review' || type === 'production') && records.length
        ? records.map((item, idx) => {
            return (
              <div key={idx}>
                <Row>
                  <p
                    style={{
                      width: 45, // fixed
                      paddingBottom: 4,
                      marginRight: 10,
                      borderBottom: '1px solid #555555',
                      marginBottom: 0,
                    }}>{`稿件${item.item_index + 1}.`}</p>
                  <Text size="sm" style={{marginRight: 5}}>
                    {cart.items[idx].name}
                  </Text>
                  <Text size="sm" style={{marginRight: 5}}>
                    {cart.items[idx].quantity}
                  </Text>
                  <Text size="sm" style={{marginRight: 5}}>
                    {item.unit} 單位
                  </Text>

                  <Text size="sm" style={{marginRight: 5}}></Text>
                  <Text size="sm" style={{marginRight: 5}}></Text>

                  {type === 'review' ? (
                    <Tag
                      text={REVIEW_STATUS[`${item.status}`]}
                      color={REVIEW_STATUS_COLORS[`${item.status}`]}
                    />
                  ) : (
                    <Tag
                      text={PRODUCTION_STATUS[`${item.production_status}`]}
                      color={
                        PRODUCTION_STATUS_COLORS[`${item.production_status}`]
                      }
                    />
                  )}
                </Row>
                <Row>
                  <div style={{flexBasis: 55}} /> {/* fixed */}
                  {item.status === 'rejected' && (
                    <>
                      <Text size="sm" style={{marginRight: 5}}>
                        不合格原因：
                      </Text>
                      <Text
                        size="sm"
                        style={{marginRight: 5}}
                        color={appConfig.colors.error}>
                        {(item.reject_reason && item.reject_reason) ||
                          '無填寫不合格原因，請洽詢客服'}
                      </Text>
                    </>
                  )}
                </Row>
                <Row>
                  <div style={{flexBasis: 55}} /> {/* fixed */}
                  {item.note && item.note !== '' && (
                    <>
                      <Text size="sm" style={{marginRight: 5}}>
                        審稿人員備註：
                      </Text>
                      <Text
                        size="sm"
                        style={{marginRight: 5}}
                        color={appConfig.colors.error}>
                        {item.note}
                      </Text>
                    </>
                  )}
                </Row>
              </div>
            );
          })
        : null}
      {type === 'logistic' &&
        (order.logistics[0] ? (
          <Row>
            <p
              style={{
                paddingBottom: 4,
                marginRight: 10,
                borderBottom: '1px solid #555555',
                marginBottom: 0,
              }}>
              狀態
            </p>
            <Text size="sm" style={{marginRight: 5}}>
              {order.logistics[0].logistics_type === 'self_pick'
                ? LOGISTIC_STATUS_SELF[order.logistics[0].logistics_status]
                : LOGISTIC_STATUS[order.logistics[0].logistics_status]}
            </Text>
          </Row>
        ) : (
          <Text size="sm" style={{marginRight: 5}}>
            無出貨單
          </Text>
        ))}

      {order.is_item_rejected && (
        <Alert message="若有不合格稿件，請至詳細頁面重新上傳" type="error" />
      )}
      <Divider />
      <Row style={{justifyContent: 'flex-end'}}>
        <Button onClick={() => app.actions.setModal()}>確定</Button>
      </Row>
    </div>
  );
}

const metadata = {
  title: false,
  width: '400px',
};

export {metadata};
